import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export const Sheet = RadixDialog.Root;
export const SheetClose = RadixDialog.Close;

interface SheetContentProps {
  children: ReactNode;
  className?: string;
}

export function SheetContent({ children, className }: SheetContentProps) {
  return (
    <RadixDialog.Portal>
      <RadixDialog.Overlay className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
      <RadixDialog.Content
        className={cn(
          'fixed inset-y-0 right-0 z-50 flex h-full w-[520px] max-w-[90vw] flex-col border-l border-border bg-card shadow-2xl focus:outline-none',
          'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right duration-300',
          className,
        )}
      >
        {/* sr-only title/description required by Radix for accessibility */}
        <RadixDialog.Title className="sr-only">Session detail</RadixDialog.Title>
        <RadixDialog.Description className="sr-only">Message thread for this session</RadixDialog.Description>

        <RadixDialog.Close className="absolute right-4 top-4 z-10 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </RadixDialog.Close>

        {children}
      </RadixDialog.Content>
    </RadixDialog.Portal>
  );
}
